import { render, staticRenderFns } from "./QuestionBoxFile.vue?vue&type=template&id=0845496a&"
import script from "./QuestionBoxFile.vue?vue&type=script&lang=js&"
export * from "./QuestionBoxFile.vue?vue&type=script&lang=js&"
import style0 from "./QuestionBoxFile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports